import React from "react";
import Resume from "../components/Resume";
import Wrapper from "../components/wrapper/index";

function ResumePage() {
  return (
    <Wrapper>
      <Resume />
    </Wrapper>
  );
}

export default ResumePage;